import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "../../../providers/data.provider";
import { SessionContextService } from "../../../context/session-context.service";
import { SessionService } from "../../../services/session.service";
import { Message, SpinnerService } from "shared-components";

@Component({
    selector: "app-email-subscription",
    templateUrl: "./email-subscription.component.html",
})

export class EmailSubscriptionComponent implements OnInit {
    @Output() pushMessage = new EventEmitter<Message>();
    @Output() refresh = new EventEmitter<boolean>();

    public showError = false;
    public mensajes = new Array<Message>();
    public emailSubscriptionForm: UntypedFormGroup;

    constructor(
        private _fb: UntypedFormBuilder,
        private _dataProvider: DataProvider,
        private _sessionContext: SessionContextService,
        private _sessionService: SessionService,
        private _spinnerService: SpinnerService,
    ) {}

    ngOnInit(): void {
        this.emailSubscriptionForm = this._fb.group({
            alertasEmail: ['', Validators.required],
            reimpresionesSnc: ['', Validators.required],
            reimpresionesNum: ['', Validators.required],
            excesosDesignaciones: ['', Validators.required],
            envioInmediato: [false],
        });

        this.getCurrentEmailSubscription();
    }

    public get alertasEmail() {
        return this._dataProvider.alertasEmail;
    }

    public get reimpresionesSnc() {
        return this._dataProvider.alertasReimpresionSnc;
    }

    public get reimpresionesNum() {
        return this._dataProvider.alertasRangoPorcentaje;
    }

    public get excesosDesignaciones() {
        return this._dataProvider.alertasRangoPorcentaje;
    }

    public close() {
        this.refresh.emit(false);
    }

    private patchEmailSubscriptionForm(data: any) {
        this.emailSubscriptionForm.patchValue({
            alertasEmail: this.alertasEmail.find((el: any) => el.id === data.applicationUserAlerta?.frecuenciaComprobacionEnvioAlertas) || this.alertasEmail[0],
            reimpresionesSnc: this.reimpresionesSnc.find((el: any) => el.id === data.applicationUserAlerta?.numReimpresionMismoSeriado) || this.reimpresionesSnc[0],
            reimpresionesNum: this.reimpresionesNum.find((el: any) => el.id === data.applicationUserAlerta?.porcentajeReimpresionExcedida) || this.reimpresionesNum[0],
            excesosDesignaciones: this.excesosDesignaciones.find((el: any) => el.id === data.applicationUserAlerta?.porcentajeDesignacionExcedida) || this.excesosDesignaciones[0],
            envioInmediato: data.applicationUserAlerta?.envioInmediatoAlerta,
        });
    }

    private getCurrentEmailSubscription() {
        this._spinnerService.showSpinner();
        const filters = {
            userName: this._sessionContext.sessionUser.userName,
        };

        this._sessionService.getAuditorEmailSubscription(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.patchEmailSubscriptionForm(resp.lista[0]);
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'emailSubscription.error.currentData' });
        });
    }

    private updateEmailSubscription() {
        this._spinnerService.showSpinner();
        const filters = {
            userName: this._sessionContext.sessionUser.userName,
            frecuenciaComprobacionEnvioAlertas: this.emailSubscriptionForm.get('alertasEmail')?.value?.id || 0,
            numReimpresionMismoSeriado: this.emailSubscriptionForm.get('reimpresionesSnc')?.value?.id || 0,
            porcentajeReimpresionExcedida: this.emailSubscriptionForm.get('reimpresionesNum')?.value?.id || 0,
            porcentajeDesignacionExcedida: this.emailSubscriptionForm.get('excesosDesignaciones')?.value?.id || 0,
            envioInmediatoAlerta: this.emailSubscriptionForm.get('envioInmediato')?.value || false,
        };

        this._sessionService.updateAuditorEmailSubscription(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.pushMessage.emit({
                class: 'success',
                message: 'emailSubscription.success.saved',
            });
            this.refresh.emit(false);
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });

    }

    public save() {
        if (this.emailSubscriptionForm.invalid) {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        } else {
            this.updateEmailSubscription();
        }
    }
}